import packageJson from '../../../package.json'


export default function Glass({config, dimensions}) {
    const aspectRatio = dimensions.width / dimensions.height

    return (
        <div
            className={`glass ${config?.biggerBottomBorder ? '-biggerBottomBorder' : ''}`}
            style={{
                backgroundColor: config?.color?.color,
                marginTop: `${aspectRatio * config.topBorder}%`,
                marginBottom: `${aspectRatio * config.bottomBorder}%`,
                // '--size': `${aspectRatio * 2}%`,
            }}
        >
            {/*<img src="img/dwm-23.png" alt="" className="glass__image"/>*/}
            {/*<img src="img/glass-texture.jpg" alt="" className="glass__texture"/>*/}
            <div className="glass__content"/>
            <div className="glass__contentFilter"/>
            <div className="glass__topLeft"/>
            <div className="glass__topRight"/>
            <div className="glass__bottomLeft"/>
            <div className="glass__bottomRight"/>
        </div>
    )
}
